import { Control, Controller } from "react-hook-form";

import { FormLabel } from "@ui/FormElements";
import { ICreateDealForm } from "@components/AddNewEntity/Deal";
import DealSourceSelect from "@components/AddNewEntity/Deal/Selects/DealSourceSelect";

interface ISourceCompanyFormFieldProps {
  control: Control<ICreateDealForm>;
}

export function SourceTypeFormField({ control }: ISourceCompanyFormFieldProps) {
  return (
    <Controller
      control={control}
      name="source_type"
      render={({ field: { value, onChange } }) => (
        <div className="flex flex-col justify-between gap-1">
          <FormLabel htmlFor="type">Source Type</FormLabel>
          <div className="w-full">
            <DealSourceSelect onChange={onChange} value={value} />
          </div>
        </div>
      )}
    />
  );
}
